import React, { useState } from "react";
import axios from "axios";

import Layout from "../components/Layout";

import { Dropdown } from "primereact/dropdown";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

import {
  FullUserLogsApi,
  VisionFullUserLogsApi,
  DigitizeFullUserLogsApi,
  WonderFullUserLogsApi,
  KickwinFullUserLogsApi,
} from "../Data/api";

const UserLogs = () => {
  const services = [
    {
      name: "kiddoCraze",
      code: "KC",
      api: FullUserLogsApi,
    },

    {
      name: "VisionGames",
      code: "VG",
      api: VisionFullUserLogsApi,
    },

    {
      name: "DigitizeAi",
      code: "DA",
      api: DigitizeFullUserLogsApi,
    },

    {
      name: "WonderMind",
      code: "WM",
      api: WonderFullUserLogsApi,
    },

    {
      name: "KickWin",
      code: "KW",
      api: KickwinFullUserLogsApi,
    },
  ];

  const [selectedService, setSelectedService] = useState(null);
  const [msisdn, setMsisdn] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // ==========================
  // Submit
  // ==========================

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedService) {
      setError("Please select service");
      return;
    }

    if (!msisdn) {
      setError("Please enter MSISDN");
      return;
    }

    setError("");
    setResult(null);
    setLoading(true);
    try {
      const response = await axios.post(selectedService.api, {
        msisdn,
      });

      console.log("FULL USER LOG RESPONSE", response.data);

      setResult(response.data.result);
    } catch (error) {
      console.log("API ERROR", error);

      setError("Error fetching data");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 px-4 py-8">
        <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-md p-5 md:p-8">
          <h1 className=" text-3xl font-bold text-center text-gray-800 mb-8">
            User Logs
          </h1>

          <form
            onSubmit={handleSubmit}
            className="flex flex-col md:flex-row items-center justify-center gap-4"
          >
            <input
              type="number"
              placeholder="Enter MSISDN"
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              className="w-full md:w-64 h-12 border rounded-xl px-4 text-center"
            />

            <div className="w-full md:w-64">
              <Dropdown
                value={selectedService}
                onChange={(e) => setSelectedService(e.value)}
                options={services}
                optionLabel="name"
                placeholder="Select Service"
                appendTo="self"
                className=" w-full h-12 border rounded-xl"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-10 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold "
            >
              Submit
            </button>
          </form>

          {/* LOADING */}

          {loading && (
            <div className=" flex justify-center my-10">
              <div className="w-14 h-14 border-4 border-blue-500 border-dashed rounded-full animate-spin"></div>
            </div>
          )}

          {/* ERROR */}

          {error && (
            <p
              className="
text-center
text-red-600
mt-5
font-medium
"
            >
              {error}
            </p>
          )}

          {/* RESULT BOXES */}

          {result && (
            <div
              className="
grid
grid-cols-1
md:grid-cols-3
gap-6
mt-10
"
            >
              {/* SUBSCRIPTION BOX */}

              <div
                className="
bg-blue-50
rounded-xl
shadow
p-5
"
              >
                <h2
                  className="
text-xl
font-bold
mb-4
"
                >
                  Subscription Details
                </h2>

                <p>
                  <b>MSISDN :</b> {result.subscription?.msisdn || "---"}
                </p>

                <p>
                  <b>Old MSISDN :</b> {result.subscription?.oldmsisdn || "---"}
                </p>

                <p>
                  <b>Subscription Date :</b>{" "}
                  {result.subscription?.subscription_date
                    ? new Date(
                        result.subscription.subscription_date,
                      ).toLocaleString()
                    : "---"}
                </p>
              </div>

              {/* BILLING BOX */}

              <div
                className="
bg-green-50
rounded-xl
shadow
p-5
"
              >
                <h2
                  className="
text-xl
font-bold
mb-4
"
                >
                  Billing Details
                </h2>

                <p>
                  <b>Billing Count :</b> {result.billing?.billing_count || 0}
                </p>

                <p>
                  <b>Charged Amount :</b> {result.billing?.charged_amount || 0}
                </p>
              </div>

              {/* UNSUB BOX */}

              <div
                className="
bg-red-50
rounded-xl
shadow
p-5
"
              >
                <h2
                  className="
text-xl
font-bold
mb-4
"
                >
                  Unsubscription Details
                </h2>

                <p>
                  <b>Unsub Date :</b>{" "}
                  {result.unsubscription?.unSubDate
                    ? new Date(result.unsubscription.unSubDate).toLocaleString()
                    : "---"}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default UserLogs;
